<template>
  <transition
    enter-active-class="transform transition duration-300"
    enter-class="opacity-0 translate-y-24"
    enter-to-class="opacity-100 translate-y-0"
    leave-active-class="transform duration-300 transition ease-in-out"
    leave-from-class="opacity-100 translate-y-0 "
    leave-to-class="opacity-0 translate-y-24"
  >
    <button
      @click="scrollTop"
      v-show="visible"
      class="fixed right-4 bottom-4 btn items-center h-8 w-8 p-6"
    >
      <font-awesome-icon
        :icon="['fas', 'chevron-down']"
        class="transform rotate-180"
      />
      <slot></slot>
    </button>
  </transition>
</template>

<script>
export default {
  props: {
    offset: {
      type: Number,
      default: 150,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    scrollTop() {
      window.scroll({
        top: 0,
        behavior: "smooth",
      });
    },
    scrollListener() {
      this.visible = window.scrollY > this.offset;
    },
  },
  mounted: function() {
    window.addEventListener("scroll", this.scrollListener);
  },
  beforeDestroy: function() {
    window.removeEventListener("scroll", this.scrollListener);
  },
};
</script>
